export const TOOLBAR_ACTIONS = {
  CREAR_RECIBO: "CREAR_RECIBO",
  APLICAR_RECIBO: "APLICAR_RECIBO",
  VER_SOLO_PENDIENTES: "VER_SOLO_PENDIENTES",
  APLICAR_FILTROS: "APLICAR_FILTROS",
  LIMPIAR_FILTROS: "LIMPIAR_FILTROS",
  EXPORTAR_PDF: "EXPORTAR_PDF",
  EXPORTAR_EXCEL: "EXPORTAR_EXCEL",
  DESACTIVAR_SOLO_PENDIENTES: "DESACTIVAR_SOLO_PENDIENTES",
  ABRIR_NOTAS: "ABRIR_NOTAS",
};
